import { render, staticRenderFns } from "./HeaderNew.vue?vue&type=template&id=0b7fc91a&scoped=true&"
import script from "./HeaderNew.vue?vue&type=script&lang=js&"
export * from "./HeaderNew.vue?vue&type=script&lang=js&"
import style0 from "./HeaderNew.vue?vue&type=style&index=0&id=0b7fc91a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b7fc91a",
  null
  
)

export default component.exports